// İSG Portal — Belge Türü Kaydı (platform document type registry), okuma tarafı.
//
// KAYNAK: api-contract §27.0-§27.1. Anahtar =
// `(entity, code)`; platform verisi, firma kapsamı yok. Yönetim uçları (liste/oluştur/güncelle)
// `documentSchemas.ts`'te.

import { api } from './client';

/** §27 — platform belge türü kaydı. Anahtar = (entity, code). Merkezî; firma kapsamı yok. */
export type DocumentEntity = 'personnel' | 'vehicle' | 'company';
export type DocumentExpiryRule = 'NoExpiry' | 'EndDateRequired' | 'EndDateOptional';
export type DocumentCaptureFormat = 'Card' | 'Page';

export interface DocumentTypeDto {
  /** Yalnız yönetici adreslemesi (PUT). İstemciler diğer her şeyi (entity, code) ile anahtarlar. */
  uuid: string;
  entity: DocumentEntity;
  /** PascalCase, değişmez, yeniden kullanılmaz. Her yerde tel üstündeki `type` / `documentType`. */
  code: string;
  labelTr: string;
  labelEn: string;
  labelDe: string;
  expiryRule: DocumentExpiryRule;
  captureFormat: DocumentCaptureFormat;
  /** Entity içinde artan; eşitlikte `code` (ordinal). */
  sortOrder: number;
  /** false: seçicilerde gizli, yeni kullanım reddedilir (INACTIVE); mevcut belgeler etiketini korur. */
  isActive: boolean;
}

/** Tür referansı taşıyan DTO'lar (§22 / §31.2 / §31.5) — `company` burada yoktur. */
export interface DocumentTypeRef {
  entity: 'personnel' | 'vehicle';
  code: string;
}

/**
 * `GET /document-types` (§4.1.1) — giriş yapmış her principal; sayfalama YOK, pasif türler
 * DAHİL (seçiciler `isActive` ile süzer). Sıra: entity, `sortOrder`, `code`.
 */
export function listPlatformDocumentTypes(params: { entity?: DocumentEntity } = {}) {
  return api.get<DocumentTypeDto[]>('document-types', {
    searchParams: { entity: params.entity },
  });
}
